import request from '@/utils/request'
export const appealApi = {
  // 申诉列表
  getappealList: (params) => {
    return request.get(`api/business/getappealList`, { params: params })
  },
  // 上传通话录音
  savephone: (data) => {
    return request.post(`/api/upload/savephone`, data)
  },
  // 上传截图
  uploadImage: (data) => {
    return request.post(`api/business/uploadImage`, data)
  },
  // 提交申诉
  saveAppeal: (data) => {
    return request.post(`api/business/saveAppeal`, data)
  },
  // 申诉详情
  getappealDetail: (params) => {
    return request.get(`api/business/getappealDetail`, { params: params })
  },
  // 申诉期限
  istimeOut: (params) => {
    return request.get(`api/business/istimeOut`, { params: params })
  },
}
